module.exports = __webpack_public_path__ + "static/media/labels.1857b793.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/labels.svg
// module id = 260
// module chunks = 0